import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

interface DiscardChangesDialogProps {
  open: boolean;
  onDiscard: () => void;
  onCancel: () => void;
}

export default function DiscardChangesDialog({
  open,
  onDiscard,
  onCancel,
}: DiscardChangesDialogProps): React.JSX.Element {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Unsaved Changes</DialogTitle>
      <DialogContent>You have unsaved changes. Leaving Edit Mode will discard them.</DialogContent>
      <DialogActions>
        <Button onClick={onDiscard} variant="text">
          Discard changes
        </Button>
        <Button onClick={onCancel} variant="contained">
          Keep editing
        </Button>
      </DialogActions>
    </Dialog>
  );
}
